import React from 'react';
import PropTypes from 'prop-types';
import ExhibitionListItem from './HomePageExhibitionListItem';

function compareExhibitionByDate(exhibition1, exhibition2) {
    return exhibition1.startDate.getTime() - exhibition2.startDate.getTime();
}

const HomePageExhibitionList = (props) => {
    return (
        <section className="container exhibitions">
            <h2>Exhibitions</h2>
            <ul className="col-sm-9 ml-auto mr-auto">
                {props.exhibitions.sort(compareExhibitionByDate).reverse().map((exhibition, i) =>
                    (
                        <ExhibitionListItem
                            key={i}
                            name={exhibition.name}
                            startDate={exhibition.startDate}
                            endDate={exhibition.endDate}
                            location={exhibition.location}
                            url={exhibition.url}
                        />
                    ))}
            </ul>
        </section>
    );
};

HomePageExhibitionList.propTypes = {
    exhibitions: PropTypes.array.isRequired
};

export default HomePageExhibitionList;



// WEBPACK FOOTER //
// ./src/components/homePage/HomePageExhibitionList.js